var map = {
	"./cs.json": "dbaZ",
	"./en.json": "cCmO",
	"./es.json": "qgB8",
	"./fr.json": "xSkN",
	"./he.json": "zRca",
	"./it.json": "2WN/",
	"./pt-BR.json": "4VIV",
	"./pt.json": "v0ES"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Lhal";